import { render, staticRenderFns } from "./ProductionBrain.vue?vue&type=template&id=09c8898e&scoped=true"
import script from "./ProductionBrain.vue?vue&type=script&lang=js"
export * from "./ProductionBrain.vue?vue&type=script&lang=js"
import style0 from "./ProductionBrain.vue?vue&type=style&index=0&id=09c8898e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c8898e",
  null
  
)

export default component.exports